<template>
    <div @mouseenter="show" @mouseleave="hide">
        <template v-if="isVisible && src">
            <div data-global="video-preview" class="global-preview" :class="{'anim-bg': isLoaded, loading: !isLoaded}">
                <video v-show="isLoaded" preload="auto" autoplay loop muted playsinline webkit-playsinline width="100" height="100" ref="video"></video>
            </div>
        </template>

        <slot></slot>
    </div>
</template>

<script>
    /**
     * @see https://cdnjs.com/libraries/hls.js
     */

    export default {
        name: 'VideoPreview',

        props: {
            src: { type: String, required: true },
            loadingTime: { type: Number, default: 500 },
            autoPlayMargin: { type: String, default: '-350px 0px' },
            mobileResolution: { type: Number, default: 767 },
        },

        data() {
            return {
                isVisible: false,
                isLoaded: false,
                loadTimer: null,
                observer: null,
                hlsInstance: null,
            };
        },

        mounted() {
            if ("IntersectionObserver" in window) {
                this.observer = new IntersectionObserver(
                    entries => {
                        if (!this.$mq.above(this.mobileResolution)) {
                            const isVisible = entries.reduce((carry, entry) => carry && entry.isIntersecting, true);
                            isVisible ? this.show() : this.hide();
                        }
                    },
                    {rootMargin: this.autoPlayMargin}
                );
                this.observer.observe(this.$el);
            }
        },

        beforeDestroy() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        },

        methods: {
            show() {
                this.isVisible = true;
                this.$nextTick(() => {
                    if (!this.src) {
                        return;
                    }
                    if ( this.src.includes(".m3u8")) {
                        if (Hls.isSupported()) {
                            this.$nextTick(() => {
                                const hlsInstance = new Hls();
                                setTimeout(() => {
                                    hlsInstance.loadSource(this.src);
                                    hlsInstance.attachMedia(this.$refs.video);
                                }, 50);
                            });
                        }
                    } else {
                        this.$refs.video.setAttribute('src', this.src );
                    }
                });
                this.isLoaded || this.load();
            },

            hide() {
                this.isVisible = false;
                this.cancelLoad();
            },

            load() {
                this.cancelLoad();

                this.loadTimer = setTimeout(() => {
                    this.isLoaded = true;
                }, this.loadingTime)
            },

            cancelLoad() {
                this.loadTimer && clearTimeout(this.loadTimer);
            }
        }
    }
</script>
